// deps
import React, { useCallback, memo } from "react";

// components
import { EMICard, IEMIBankPlan, IEMITenure } from "@swiggy-private/dls-web-recipe-common-web/dist/components/EMICard";

// styles
import { Separator } from "../EMIPlanList.styled";

interface EMICardWrapperProps {
    emi: IEMIBankPlan;
    cardId: string;
    selectedCardId: string | null;
    onCardSelection: (cardId: string | null) => void;
    onCTAClick: (emiPlan: IEMIBankPlan, tenure: IEMITenure) => void;
    showSeparator: boolean;
    onEMIExpandClick: VoidFunction;
    onEMITncClick: VoidFunction;
}

const EMICardWrapper = ({
    emi,
    cardId,
    selectedCardId,
    onCardSelection,
    onCTAClick,
    showSeparator,
    onEMIExpandClick,
    onEMITncClick,
}: EMICardWrapperProps) => {
    const handleEMIProceedClick = useCallback(
        (emiPlan: IEMIBankPlan, tenure: IEMITenure) => {
            onCTAClick(emiPlan, tenure);
        },
        [onCTAClick],
    );

    return (
        <React.Fragment>
            <EMICard
                selectionMode
                emiData={emi}
                cardId={cardId}
                selectedCardId={selectedCardId}
                onCardSelection={onCardSelection}
                onEMIProceedClick={handleEMIProceedClick}
                ctaText={"Confirm & Review Bill Details"}
                onCardExpandEvent={onEMIExpandClick}
                onReadMoreClickEvent={onEMITncClick}
            />
            {showSeparator && <Separator />}
        </React.Fragment>
    );
};

export default memo(EMICardWrapper);
